import { Card, CardContent, CardHeader, Stack, Grid2, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import { useEffect, useState } from "react";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MaterialSnackbar from "../../components/MaterialSnackbar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";



const Permission = () => {

      const data = sessionStorage.getItem("user")
      const parsedData = JSON.parse(data);
      const encodedId = parsedData?.id;
      const encryted = btoa(encodedId)
      console.log(parsedData,"lv")


    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
     const nav = useNavigate()
      const [dialogopen,setdialogopen] = useState(false)
      const[Snackbar,setSnackbar]  = useState(false)
      const[updateid,setupdateid] = useState('')


      

     const addmutation =`
     
  mutation CreatePermission(  
  $userId: ID!, 
  $permissionOn: Date!, 
  $permissionFrom: Time!, 
  $permissionTill: Time!, 
  $reason: String!
) {
  createPermission(
    userId: $userId, 
    permissionOn: $permissionOn, 
    permissionFrom: $permissionFrom, 
    permissionTill: $permissionTill, 
    reason: $reason
  ) {
    permission {
      id
      permissionOn
      permissionFrom
      permissionTill
      reason
      balanceHours
    }
    balanceHours
  }
}
     
     
     
     `

     const updatemutation =`
       
  mutation UpdatePermission(
  $permissionId: ID!, 
  $permissionOn: Date, 
  $permissionFrom: Time, 
  $permissionTill: Time, 
  $reason: String
) {
  updatePermission(
    permissionId: $permissionId, 
    permissionOn: $permissionOn, 
    permissionFrom: $permissionFrom, 
    permissionTill: $permissionTill, 
    reason: $reason
  ) {
    permission {
      id
      permissionOn
      permissionFrom
      permissionTill
      reason
      balanceHours
    }
    balanceHours
  }
}
     
     
     `
  

     const getpermission = `
      

 query GetPermissionById($id: ID!) {
  permissionById(id: $id) {
    id
    user {
      id
      username
    }
    permissionOn
    permissionFrom
    permissionTill
    reason
    balanceHours
    teamApproval
    hrApproval
    status
    createdAt
  }
}
     
 
     `

     const fetchpermissionhours =`
      

     query PermissionsByUser($userId: ID!) {

  permissionsByUser(userId: $userId) {

    id

    user {

      username

      id

      firstName

      lastName

      teamleader

    }

    permissionOn

    permissionFrom

    permissionTill

    reason

    balanceHours

    hrApproval

    teamApproval

    status

    createdAt

  }

}
 
     
     
     `

     const [remaininghours,setremaininghours] = useState("")
     const [permission, setPermission] = useState({

        userId: encodedId, 
        permissionOn:"", 
        permissionFrom:"", 
        permissionTill: "", 
        reason: ""
          });
      console.log(remaininghours,"per")
     useEffect(()=>{

        const fetchpermission = async ()=>{
            try{
                const response =   await axios.post(
                    BASEURL,
                    {
                      query: fetchpermissionhours,
                      variables: { 
                        userId: "VXNlck5vZGU6" + "" + encryted,
                       },
                    },
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    }
                  );
    
                  // console.log(response.data.data.permissionById.
                  //   balanceHours,"resp")
                  setremaininghours(4)
                  
                      console.log(response.data.data.permissionsByUser[0].balanceHours,"fetper")
               

                       setremaininghours(response.data.data.permissionsByUser[0].balanceHours)
            }
            catch(error){
                console.log(error,"err")
            }
    
        }
    
        fetchpermission()

     },[])


    const [iseditatable,seteditable] = useState(true)
   
           console.log(iseditatable,"edit")
   
    const query =`
    
         
    
    
    `
      console.log(id,"id")
    useEffect(()=>{
        if(id){
          console.log("inside effect")
        const fetchpermission = async ()=>{
        try{
            const response =   await axios.post(
                BASEURL,
                {
                  query: getpermission,
                  variables: { id },
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

              console.log(response.data.data.permissionById
                ,"respd")

              setremaininghours(response.data.data.permissionById.
                balanceHours)

                setPermission(

                    {
                        permissionId: response.data.data.permissionById.id,
                        permissionOn: response.data.data.permissionById.permissionOn,
                        permissionFrom: response.data.data.permissionById.permissionFrom,
                        permissionTill:response.data.data.permissionById.permissionTill,
                        reason: response.data.data.permissionById.reason
                        }

                )
              seteditable(false)

        }
        catch(error){
            console.log(error,"err")
        }

    }

    fetchpermission()
} 


    },[id])

     
  // const [errors, setErrors] = useState({
  //   TotalPermissionsHours: false,
  //   permissionOn: false,
  //   permissionFrom: false,
  //   permissionTill: false,
  //   reason:false
  // });

 



 

  // const handleChange = (e) => {
   
  //   const { name, value } = e.target;
  //       console.log(value,"val")

  //       if(name=="remaininghours"){

  //           setremaininghours(value)
  //       }
 
  //       console.log(name,"name")
  //   // Update the permission state
  //   setPermission((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));

  //   // Validation logic for each field
  //   let isValid = true;
  //   if (name === "remaining" && (isNaN(value) || value <= 0)) {
  //     isValid = false;
  //   }
  //   if (name === "permissionOn" && !value) {
  //     isValid = false;
  //   }
  //   if ((name === "permissionFrom" || name === "permissionTill") && !value) {
  //     isValid = false;
  //   }
  //   if(name === "reason" && !value){

  //       isValid=false
  //   }

  //   if (name === "permissionFrom" || name === "permissionTill") {
  //     const fromTime = permission.permissionFrom;
  //     const tillTime = permission.permissionTill;

  //     console.log(fromTime,"ft")
  //     console.log(tillTime,"tt")
  
  //     if (fromTime && tillTime && fromTime <= tillTime) {
  //       isValid=false
  //     }
  //   }

  //   // Update error state
  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: !isValid,
  //   }));
  // };
  //  console.log(errors)
  // const isFormValid = () => {
  //   return (
  //     remaininghours &&
      
  //     permission.permissionOn &&
  //     permission.permissionFrom &&
  //     permission.permissionTill &&
  //     permission.reason&&
  //     !Object.values(errors).includes(true)
  //   );
  // };
  
  const [errors, setErrors] = useState({
    TotalPermissionsHours: false,
    permissionOn: false,
    permissionFrom: false,
    permissionTill: false,
    reason: false,
    timeOrder: false, // New error state for time order validation
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Update permission state
    setPermission((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // Validation logic
    let isValid = true;
  
    if (name === "remaininghours" && (isNaN(value) || value <= 0)) {
      isValid = false;
    }
    if (name === "permissionOn" && !value) {
      isValid = false;
    }
    if ((name === "permissionFrom" || name === "permissionTill") && !value) {
      isValid = false;
    }
    if (name === "reason" && !value) {
      isValid = false;
    }
  
    
    let timeOrderValid = true;
    let fromTime = name === "permissionFrom" ? value : permission.permissionFrom;
    let tillTime = name === "permissionTill" ? value : permission.permissionTill;
  
    if (fromTime && tillTime && fromTime >= tillTime) {
      timeOrderValid = false;
    }
  
    // Update error state
    setErrors((prev) => ({
      ...prev,
      [name]: !isValid,
      timeOrder: !timeOrderValid, // Set error for invalid time order
    }));
  };
  
  const isFormValid = () => {
    return (
      remaininghours &&
      permission.permissionOn &&
      permission.permissionFrom &&
      permission.permissionTill &&
      permission.reason &&
      !Object.values(errors).includes(true)
    );
  };
  
   console.log(errors,"err")
  
  
  console.log("Form Submitted Successfully");
  const handleSubmit = async() => {

    setdialogopen(true)
    // console.log("insidesubmit");
    // if (isFormValid()) {
    //   console.log("Form Submitted Successfully", permission);

    //   alert("form submitted", permission);

    //   if(id){
    //     //update


    //     try{
    //         const response =   await axios.post(
    //             BASEURL,
    //             {
    //               query: updatemutation,
    //               variables:permission,
    //             },
    //             {
    //               headers: {
    //                 "Content-Type": "application/json",
    //               },
    //             }
    //           );

    //           console.log(response,"resp")
            

    //     }
    //     catch(error){
    //         console.log(error,"err")
    //     }
    //   }
    //   else{

    //     //create

    //     try{
    //         const response =   await axios.post(
    //             BASEURL,
    //             {
    //               query: addmutation,
    //               variables: 
                   
    //                     permission
                    


    //               ,
    //             },
    //             {
    //               headers: {
    //                 "Content-Type": "application/json",
    //               },
    //             }
    //           );

    //           console.log(response,"resp")
           

    //     }
    //     catch(error){
    //         console.log(error,"err")
    //     }


    //   }
    // } else {
    //   console.log("Please fill all fields correctly.");
    // }
  };

  //handleclose

  const handleclose = ()=>{


    setdialogopen(false)
  }

  const confirmsubmit = async()=>{
    

    console.log("insidesubmit");
    if (isFormValid()) {
      console.log("Form Submitted Successfully", permission);

      

      if(id){
        //update


        try{
            const response =   await axios.post(
                BASEURL,
                {
                  query: updatemutation,
                  variables:permission,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

              console.log(response,"resp")
            

        }
        catch(error){
            console.log(error,"err")
        }
      }
      else{

        //create

        try{
            const response =   await axios.post(
                BASEURL,
                {
                  query: addmutation,
                  variables: 
                   
                        permission
                    


                  ,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

              console.log(response,"resp")
           

        }
        catch(error){
            console.log(error,"err")
        }



      }
    } else {
      console.log("Please fill all fields correctly.");
    }


     setdialogopen(false) 
    //  setSnackbar(true)
    
      Swal.fire({
       
        position: "center",
        icon: "success",
        title: "Permission Requested successfully!",
        showConfirmButton: false,
        timer: 2500,


      })

     nav("/permission")
  }

  return (
    <DashboardLayout>
       <Dialog open={dialogopen} onClose={handleclose}>
           <DialogTitle>Confirmation</DialogTitle>
           <DialogContent>Are you sure do you want to submit your details.</DialogContent>
           <DialogActions>
          <Button onClick={handleclose}>Cancel</Button>
          <Button onClick={confirmsubmit} >Confirm</Button>
        </DialogActions>
       </Dialog>

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Permission
                </MaterialTypography>
              </Stack>
          

             { id&&<MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={()=>seteditable(true)}
            >
              Edit
            </MaterialButton>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
             
              onClick={""}
            >
              Delete
            </MaterialButton>
          </MaterialBox>}



            </Stack>
          }
        />

        <CardContent>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Permission Details
            </MaterialTypography>
          </Stack>

          <MaterialBox>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    TotalPermissionsHours <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="remaining"
                  disabled
                  value={remaininghours}
                  onChange={handleChange}
                  error={errors.TotalPermissionsHours}
                  success={!errors.TotalPermissionsHours}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    PermissionFrom <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="permissionFrom"
                  type="time"
                  value={permission.permissionFrom}
                  onChange={handleChange}
                  error={errors.permissionFrom || errors.timeOrder}
                  disabled={!iseditatable}
                  success={permission.permissionFrom&&!errors.permissionFrom && !errors.timeOrder}
                />
                {
                 errors.timeOrder? <span style={{color:"red",fontSize:"15px"}}>
                   from time should be lesser than till time
                  </span>:null
                }
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    PermissionTill <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="permissionTill"
                  type="time"
                  value={permission.permissionTill}
                  onChange={handleChange}
                  disabled={!iseditatable}
                  error={errors.permissionTill || errors.timeOrder}
                  success={permission.permissionTill&&!errors.permissionTill && !errors.timeOrder}

                
                />
                  {
                 errors.timeOrder? <span style={{color:"red",fontSize:"15px"}}>
                   from time should be lesser than till time
                  </span>:null
                }
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    PermissionOn <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="permissionOn"
                  type="date"
                  value={permission.permissionOn}
                  onChange={handleChange}
                  error={errors.permissionOn
                  }
                  disabled={!iseditatable}
                  success={permission.permissionOn&&!errors.permissionOn}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={7}
                  name="reason"
                  // placeholder="eg. IT"
                  value={permission.reason}
                  onChange={handleChange}
                  disabled={!iseditatable}
                  success={permission.reason&&!errors.reason}
                  error={errors.reason}
                //   success={roleData.descriptionStatus === "success"}
                //   disabled={togglePage.view === true ? true : false}
                />
              </Grid2>
            </Grid2>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => setPermission({})}
            >   
              Cancel
            </MaterialButton>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!isFormValid()}
              onClick={() => handleSubmit()}
            >
              Submit
            </MaterialButton>
          </MaterialBox>
        </CardContent>

        <MaterialSnackbar
        
          color="success"
          icon={<NotificationsIcon />}
          title="Message"
          content="You have been submitted successfully"
          open={Snackbar}
          close={()=>{
            setSnackbar(false)
            nav("/permission")
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Permission;
